import { render } from "./ScreenDemoWithQuestionGG.vue?vue&type=template&id=333eb268&scoped=true&ts=true"
import script from "./ScreenDemoWithQuestionGG.vue?vue&type=script&lang=ts"
export * from "./ScreenDemoWithQuestionGG.vue?vue&type=script&lang=ts"

import "./ScreenDemoWithQuestionGG.vue?vue&type=style&index=0&id=333eb268&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333eb268"]])

export default __exports__